import './HScroll.css';

import PropTypes from 'prop-types';

const HScroll = ({ children, type, className }) => {
  HScroll.propTypes = {
    children: PropTypes.any,
    type: PropTypes.string,
    className: PropTypes.string
  };

  return (
    <div
      className={className ? `${className} hscroll-container` : 'hscroll-container'}
      style={{ width: type === 'fill' ? '100%' : type }}>
      <div className="hscroll-scroll">{children}</div>
    </div>
  );
};

export default HScroll;
